<script>
import {
  required,
} from "vuelidate/lib/validators";

export default {
    page: {
        title: "Panel İşlemleri",
    },
    data() {
        return {
            submitted:false,
            form:{ old_password: '', new_password: '' },
        };
    },
    validations: {
        form:{
            old_password: { required },
            new_password: { required },
        }
    },
    mounted() {},
    methods: {
        portalTransaction() {
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                return;
            }
            // submit to backend
            this.$http.post('/me/passwordChange', this.form)
                .then(response => {
                    if(response.data.error){
                        return this.$bvToast.toast(response.data.message || 'Hata', { variant: 'danger' })
                    }

                    const userdata = JSON.parse(localStorage.getItem('userdata') || '{}')
                    localStorage.setItem('userdata', JSON.stringify({ ...userdata, password_change: null }))
                    this.$bvToast.toast(response.data.message || 'Başarılı', { variant: 'success' })
                })
                .finally(() => { this.submitted = false })
        },
    }
};
</script>

<template>
<div class="row">
    <div class="col-md-5">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <form class="needs-validation" @submit.prevent="portalTransaction">
                    <div class="md-6">
                        <b-form-group
                            class="mb-3"
                            label="Şuanki Şifreniz"
                            label-cols-sm="5"
                        >
                            <b-form-input
                                v-model="form.oldpassword"
                                type="text"
                                placeholder="Şuanki Şifreniz"
                                :class="{
                                    'is-invalid': submitted && $v.form.oldpassword.$error,
                                }"
                            ></b-form-input>
                            <div
                                v-if="submitted && $v.form.oldpassword.$error"
                                class="invalid-feedback"
                                >
                                <span v-if="!$v.form.oldpassword.required">Bu alan zorunludur.</span>
                            </div>
                        </b-form-group>
                        <b-form-group
                            class="mb-3"
                            label="Yeni Şifreniz"
                            label-cols-sm="5"
                            >
                            <b-form-input
                                v-model="form.newpassword"
                                type="text"
                                placeholder="Yeni Şifreniz"
                                :class="{
                                    'is-invalid': submitted && $v.form.newpassword.$error,
                                }"
                            >
                            </b-form-input>
                            <div
                                v-if="submitted && $v.form.newpassword.$error"
                                class="invalid-feedback"
                                >
                                <span v-if="!$v.form.newpassword.required">Bu alan zorunludur.</span>
                            </div>
                        </b-form-group>
                        </div>
                        <div class="col-md-12">
                            <div class="mb-3 d-flex justify-content-end">
                                <button class="btn btn-warning" type="submit">Güncelle</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
</template>